module.exports = __webpack_public_path__ + "assets/img/15_336_big.e84cf915.jpg";